import React, {FC, useMemo, useState} from 'react';

import {CtaButton, RadioButton} from '@optimaxdev/design-system';
import scroller from 'react-scroll/modules/mixins/scroller';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {PaymentMethodsType} from 'types/PaymentMethodsType';

import {getBnplOfferPopupList} from './constant';

import s from './bnplOfferPopupList.scss';

type BnPlOfferPopupListPropType = {
    changePayment: (code: PAYMENTS) => void;
    setIsClose: (arg: boolean) => void;
    paymentMethods: PaymentMethodsType;
};
type PaymentMethodButtonPropType = {
    title: React.ReactNode;
    description: React.ReactNode;
    name: string;
    code: PAYMENTS;
    isSelected: boolean;
    onSelect: (name: string, code: PAYMENTS) => void;
};
const PaymentMethodButton: FC<PaymentMethodButtonPropType> = ({
    code,
    description,
    isSelected,
    name,
    onSelect,
    title,
}) => (
    <button
        className={s.paymentButtonsList}
        data-testid={code}
        onClick={() => onSelect(name, code)}
        type="button"
    >
        <div className={s.titleContainer}>
            <RadioButton isChecked={isSelected} size="small" value="false" verticalAlign="center" />
            {title}
        </div>
        {description}
    </button>
);

/**
 * BnPlOfferPopupList - popup interface for selecting a payment method and continuing with the selected method.
 */
export const BnPlOfferPopupList: FC<BnPlOfferPopupListPropType> = ({
    changePayment,
    paymentMethods,
    setIsClose,
}) => {
    const [paymentMethodCode, setPaymentMethodCode] = useState(PAYMENTS.METHOD_CREDIT_CARD);
    const [selectedPaymentMetHod, setSelectedPaymentMethod] = useState('Credit Card');

    /**
     *  filtered payment methods
     */
    const filteredPaymentMethods = useMemo(
        () =>
            getBnplOfferPopupList().filter(({code}) =>
                Object.keys(paymentMethods.list).includes(code),
            ),
        [paymentMethods],
    );

    const handlePaymentMethodSelect = (name: string, code: PAYMENTS) => {
        setSelectedPaymentMethod(name);
        setPaymentMethodCode(code);
    };

    const handleContinueButtonClick = () => {
        changePayment(paymentMethodCode as PAYMENTS);
        scroller.scrollTo(paymentMethodCode, {
            duration: 1000,
            isDynamic: true,
            offset: -400,
            smooth: true,
        });
        setIsClose(false);
    };

    return (
        <div className={s.listContainer}>
            <div className={s.paymentButtonsListContainer}>
                {filteredPaymentMethods.map(({code, description, name, title}) => (
                    <PaymentMethodButton
                        code={code}
                        description={description}
                        isSelected={selectedPaymentMetHod === name}
                        key={code}
                        name={name}
                        onSelect={handlePaymentMethodSelect}
                        title={title}
                    />
                ))}
            </div>
            <CtaButton
                className={s.button}
                colorName="secondary"
                onClick={handleContinueButtonClick}
                size="large"
                type="submit"
            >
                Continue with {selectedPaymentMetHod}
            </CtaButton>
        </div>
    );
};
